import { AxiosRequestConfig } from "axios";

import { envConfig } from "config/env";

import { apiClient, CustomAxiosRequest } from ".";

type putCertificacionPropsType = {
	iteId: string;
	tipo: "ite" | "bim";
	fecha: string | undefined;
};

export const putCertificacion: CustomAxiosRequest<putCertificacionPropsType[], undefined> = (props) => {
	const url = `ite/ite/certificar`;
	const config: AxiosRequestConfig = {
		method: "PUT",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		data: props,
	};
	return apiClient(config);
};

type CertificarBulkFilters = {
	estadoITE?: string[];
	estadoLevantamiento?: string[];
	estadoFichaInventario?: string[];
	resultadoITE?: string[];
	ambito?: string[];
	jefatura?: string[];
	agrupacion?: string[];
	provincia?: string[];
	especialidad?: string[];
	uso?: string[];
	relevancia?: string[];
	empresa?: string[];
	tipologia?: string[];
	tecnico?: string[];
	searchText?: string;
	porValidar?: string[];
	via?: string;
	estacion?: string;
	categoriaMejoras?: string[];
	tipoEdificio?: string[];
	prioridadReparacion?: string[];
	indiceNEC?: string[];
	indiceNEE?: string[];
	indiceNAE?: string[];
	indiceNCN?: string[];
	fechaVisita?: string[];
	fechaVisitaProxIte?: string[];
	fechaEntregaIteFrom?: string;
	fechaEntregaIteTo?: string;
	fechaEntregaBimFrom?: string;
	fechaEntregaBimTo?: string;
	fechaCertificacionIteFrom?: string;
	fechaCertificacionIteTo?: string;
	fechaCertificacionBimFrom?: string;
	fechaCertificacionBimTo?: string;
	iteEntregada?: boolean;
	iteCertificada?: boolean;
	bimEntregado?: boolean;
	bimCertificado?: boolean;
	type?: string[];
	revisedAtFrom?: string;
	revisedAtTo?: string;
	responseDateFrom?: string;
	responseDateTo?: string;
	revised?: boolean;
	replied?: boolean;
	tipoIte?: string[];
};

type PutCertificacionBulkProps = {
	tipo: "ite" | "bim";
	fecha?: string;
	filters: CertificarBulkFilters;
	view?: string;
};

export const putCertificacionBulk: CustomAxiosRequest<PutCertificacionBulkProps, number> = (props) => {
	const url = `ite/ite/${envConfig.PROJECT_REF}/certificar-bulk`;
	const config: AxiosRequestConfig = {
		method: "PUT",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		data: props,
	};
	return apiClient(config);
};
